// Local translations
export const T = {
  en_GB: {
    cancelEdit: "Cancel",
    confirm: "Confirm",
    edit: "Edit",
    documents: "Process",
    cancelAdvice: "Cancel",
    reopen: "Reopen flow",
    submit: "Submit",
    // Why "Reopen flow" is shown but disabled.
    blockedSigned: "A document has already been signed. This flow cannot be reopened.",
    blockedSignedHint: "View signatures and available signing actions in Process.",
    saving: "Saving...",
    inviteClient: "Invite Client",
    // Tooltips
    cannotSubmitUnsuitableProducts: "Cannot submit: Portfolio contains unsuitable products",
    cannotSubmitWithdrawalsExceed:
      "Cannot submit: Planned withdrawals exceed projected portfolio value",
    cannotSubmitSnapshotsStale:
      "Cannot submit: portfolio snapshots are out of date. Click 'Refresh snapshots' to continue.",
    cannotSubmitSnapshotsRegenerating:
      "Cannot submit yet: portfolio snapshots are being updated. Submit unlocks by itself when they are done.",
    cannotSubmitPreview: "Cannot submit: this flow is in preview — only designers can submit it.",
  },
  nb_NO: {
    cancelEdit: "Avbryt",
    confirm: "Bekreft",
    edit: "Rediger",
    documents: "Prosess",
    cancelAdvice: "Kanseller",
    reopen: "Gjenåpne flyten",
    submit: "Send inn",
    blockedSigned: "Et dokument er allerede signert. Denne flyten kan ikke gjenåpnes.",
    blockedSignedHint: "Se signaturer og tilgjengelige signeringshandlinger i Prosess.",
    saving: "Lagrer...",
    inviteClient: "Inviter kunde",
    // Tooltips
    cannotSubmitUnsuitableProducts: "Kan ikke sende inn: Porteføljen inneholder uegnede produkter",
    cannotSubmitWithdrawalsExceed:
      "Kan ikke sende inn: Planlagte uttak overstiger forventet porteføljeverdi",
    cannotSubmitSnapshotsStale:
      "Kan ikke sende inn: Porteføljedataen er utdatert. Klikk «Oppdater snapshots» for å fortsette.",
    cannotSubmitSnapshotsRegenerating:
      "Kan ikke sende inn ennå: Porteføljedataen oppdateres. Innsending blir tilgjengelig av seg selv når det er ferdig.",
    cannotSubmitPreview:
      "Kan ikke sende inn: denne flyten er i forhåndsvisning — bare designere kan sende den inn.",
  },
} as const;
